import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { PageTabItem } from './page-tab-item';

@Component({
  selector: 'app-page-tabs',
  templateUrl: './page-tabs.component.html',
  styleUrls: ['./page-tabs.component.scss']
})
export class PageTabsComponent implements OnInit {

  @Input() tabs: Array<PageTabItem>;
  @Input() id: string;
  @Input() validacaoCustom: boolean;
  @Input() invertColors = false;
  @Input() active = 0;

  constructor(public cdRef: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  validTab(div: string): boolean {
    // TODO
    // const divId = divName.replace('#', '');
    // const valid = document.getElementById(divId)?.getElementsByClassName('ng-invalid').length || 0;
    // return valid === 0;
    return div != null;
  }
}
